import axios from 'axios';

export default {
	async authenticate (username, password) {
		try {
			return await axios.post('users/authenticate', {
				username,
				password
			});
		} catch (error) {
			throw error;
		}
	},
	async reauthenticate (token) {
		try {
			return await axios.post('users/reauthenticate', {jwt: token});
		} catch (error) {
			throw error;
		}
	},
	async getCurrentUser (uuid) {
		try {
			return await axios.get(`/users/uuid/${uuid}`);
		} catch (error) {
			throw error;
		}
	}
};


// WEBPACK FOOTER //
// ./src/api/auth.js